import {createApp} from 'vue';
import {createPinia} from 'pinia';
import PerfectScrollbar from 'vue3-perfect-scrollbar';
import VueSocialSharing from 'vue-social-sharing'
import VWave from 'v-wave'
import {App as CapacitorApp} from '@capacitor/app';
import {Settings} from "luxon";
import {Calendar, setupCalendar} from 'v-calendar';
import posthog from 'posthog-js';

import './init/import-supertokens';
import './init/import-css';
import {applyPrimeVue, applyToast} from './init';
import {createRouterObject} from './router/router';
import App from './App.vue';
import {Capacitor} from "@capacitor/core";
import VueGtag from "vue-gtag";

import type {TooltipConfiguration} from '@programic/vue3-tooltip';
import Tooltip from '@programic/vue3-tooltip';
import '@programic/vue3-tooltip/dist/index.css';

Settings.defaultLocale = 'he';
declare let ClarityPlugin: any;

if (Capacitor.getPlatform() === "android") {
  document.addEventListener('gesturestart', (event) => {
    event.preventDefault();
  }, false);

  ClarityPlugin.initialize("qrn6ao1qfz", (message: string) => {
  }, (message: string) => {
  }, {isIonic: true});
}

const app = createApp(App);
const router = createRouterObject();

applyPrimeVue(app);
applyToast(app);

app.use(createPinia());
app.use(router);
app.use(PerfectScrollbar);
app.use(VueSocialSharing);
app.use(setupCalendar, {})
app.component('VCalendar', Calendar)

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
app.use(VWave)
app.use(Tooltip, {placement: 'bottom'} satisfies TooltipConfiguration);

app.use(VueGtag, {
  includes: [
    {id: "AW-16622960794"},
  ],
  config: {id: "G-XGRX6YNVQE"}
})

CapacitorApp.addListener('backButton', ({canGoBack}) => {
  if (!canGoBack) {
    CapacitorApp.exitApp();
  } else {
    router.back();
  }
});

if (!import.meta.env.VITE_DASHBOARD_URL?.includes('localhost')) {
  const originalConsoleError = console.error;
  console.error = function (...args: unknown[]) {
    originalConsoleError.apply(console, args);
    try {
      const error = args[0] instanceof Error ? args[0] : new Error(args.map(String).join(' '));
      posthog.captureException(error);
    } catch (_) { /* noop */ }
  };

  window.addEventListener('error', (event) => {
    posthog.captureException(event.error || new Error(event.message));
  });

  window.addEventListener('unhandledrejection', (event) => {
    const error = event.reason instanceof Error ? event.reason : new Error(String(event.reason));
    posthog.captureException(error);
  });
}

app.mount('#app');

